export default function buildGetStartedModuleFragmentFragment(
  data?: Partial<Queries.GetStartedModuleFragmentFragment>
): Queries.GetStartedModuleFragmentFragment {
  return {
    __typename: "ContentfulGetStartedModule",
    title: null,
    body: null,
    ctaButtons: null,
    layout: null,
    videoBehavior: null,
    eyebrow: null,
    videoControls: null,
    visibleIn: null,
    form: null,
    videoSource: null,
    darkMode: false,
    videoThumbnail: null,
    image: null,
    ...data,
  };
}
